export default "__VITE_ASSET__07755cba__"